import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { getDataLayerVal } from "utils/datalayerextraction";

class AJAXLoadContent extends Class {
  constructor(element) {
    super();
    this.element = $(element);
    this.url = this.element.data("url");
    this.cacheBust = this.element.data("cacheBust");
    this.replaceContent = this.element.data("replaceContent");
    this.rejectParents = this.element.data("rejectParents");
    this.async = this.element.data("ajaxAsync");
    if (!this.url) {
      throw new Error("Please supply a data-url attribute to load content.");
    }
    // skip ajax call if it matches parent elements with those selectors
    if(!this.rejectParents||!this.element.parents(this.rejectParents).length){
      this.updateParameters();
      this.load();
    }
  }

  qs() {
    if (window.mostThisObj) {
      return $.param(mostThisObj[0] || {});
    }
  }
    
    updateParameters() {
        //all widgets need clearcache=1 if return from ad or clearcache=1 in url
        var clearcache = this.url.toLowerCase().indexOf("clearcache=1") === -1 && (document.location.href.toLowerCase().indexOf("adredir=1") !== -1 || document.location.href.toLowerCase().indexOf("clearcache=1") !== -1) ? true : false;

        this.url = clearcache && this.url.indexOf("?") !== -1 ? this.url + "&clearcache=1" : clearcache ? this.url + "?clearcache=1" : this.url;

        this.url = this.url
            .replace("storytoken=1", `storycode=${getDataLayerVal("StoryID")}`)
            .replace("navtoken=1", `navcode=${getDataLayerVal("NavCode")}`)
            .replace(
                "micrositetoken=1",
                `micrositenavcode=${getDataLayerVal("MicrositeNavCode")}`
            );
  }

  load() {
    var self = this;
    $.ajax({
      async: this.async || true,
      url: this.url,
      data: this.qs(),
      cache: this.cacheBust ? false : true,
      success: (data, status, xhr) => {
        if (status === "success" || data.length) {
          if ($(this.element).find(".__skeleton-loader").length) {
            $(this.element)
              .find(".__skeleton-loader")
              .replaceWith(data);
          } else if(this.replaceContent){
            $(this.element).html(data);
          } else {
            $(this.element).append(data);
          }
          $(window).trigger("abacus:InitUI", this.element);
        } else {
          $(this.element).append(
            `<p class="error">There was an error loading the content.</p>`
          );
        }
      },
      complete: () => {
        $(window).trigger("abacus:loadcontent:complete", [self.element]);
        $(window).trigger("abacus:customwidget:complete", [self.element]);
      }
    });
  }
}
export { AJAXLoadContent };



// WEBPACK FOOTER //
// ./Javascript/core/classes/loadmoreitems/ajax.loadcontent.class.js